import { LicenseGroup } from "../../Models/LicenseGroup";
import { ProjectFormData } from "../../Models/ProjectFormData";
import { ActionTypes } from "../ProjectActionTypes";
import { ProjectModalAction } from "./ProjectModalActions";
import {
  IProjectModalState,
  initialProjectModalState,
} from "./ProjectModalState";

export const ProjectModalReducer = (
  state: IProjectModalState = initialProjectModalState,
  action: ProjectModalAction
): IProjectModalState => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_PROJECT: {
      console.log(action);
      return { ...state, loaded: false, errorCode: undefined };
    }
    case ActionTypes.GET_PROJECT_SUCCESS: {
      console.log(action);
      return {
        ...state,
        loaded: true,
        project: payload?.project ? payload.project : ({} as ProjectFormData),
        interfaces_old: payload?.interfaces_old,
        dailyjobs: payload?.dailyjobs,
        dataconnections: payload?.dataconnections,
        errorCode: undefined,
      };
    }
    case ActionTypes.GET_PROJECT_ERROR: {
      console.log(action);
      return {
        ...state,
        loaded: true,
        project: {} as ProjectFormData,
        licenses: {} as LicenseGroup,
        errorCode: payload?.errorCode,
      };
    }
    case ActionTypes.CLEAR_PROJECT: {
      console.log(action);
      return {
        ...state,
        loaded: false,
        project: {} as ProjectFormData,
        interfaces_old: [],
        licenses: {} as LicenseGroup,
        errorCode: undefined,
      };
    }
    case ActionTypes.SET_PROJECT: {
      console.log(action);
      return {
        ...state,
        project: payload?.project,
      };
    }

    case ActionTypes.ADD_PROJECT_ERROR:
    case ActionTypes.UPDATE_PROJECT_ERROR: {
      console.log(action);
      return {
        ...state,
        errorCode: payload?.errorCode,
      };
    }

    case ActionTypes.GET_PROJECT_LICENSES: {
      console.log(action);
      return {
        ...state,
        licenses: payload?.projectLicenses,
      };
    }

    default:
      return state;
  }
};
